module.exports = __webpack_public_path__ + "media/images/edit-d8fbc1ddb7baf356f4f157f7d1bd070f.png";